<section>
  <a
    class="link"
    data-testid="back-from-change-mbb-link"
    tabindex="0"
    (click)="finishedSelection.emit()"
    (keydown.enter)="finishedSelection.emit()"
  >
    <mat-icon [svgIcon]="IconNames.ice_arrow_left" />
    <span class="link-text">Tilbake</span>
  </a>
  @if (mbbProduct.isLoadingSubscriptionOfferings) {
    <app-spinner />
  } @else {
    <div class="offerings">
      <h4>Endre abonnement</h4>
      <form [formGroup]="form">
        <app-mbb-subscription
          [assignedSubscription]="mbbProduct.assignedSubscription"
          [mbbAllowedOfferings]="mbbProduct.allowedSubscriptionOfferings"
          [mbbProduct]="mbbProduct"
          (mbbSubscriptionChange)="onProductChange($event)"
        />
      </form>
    </div>
  }
</section>
